import React from "react";
import { Container } from "react-bootstrap";
import parse from "html-react-parser";
import "./index.css";

export default function Disclaimers({ data }) {
  if (!data?.disclaimer?.data || data.disclaimer.data.length === 0) {
    return null;
  }

  return (
    <section className="disclaimer-section">
      <Container>
        <div className="disclaimer-container">
          {data.disclaimer.data.map((disclaimer, index) => (
            <p key={index} className="disclaimer-text">
              {parse(disclaimer)}
            </p>
          ))}
        </div>
      </Container>
    </section>
  );
}
